/** @format */

import React from "react";

export default () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 132 131"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M65.9998 129.962C102.169 129.962 131.5 100.986 131.5 65.2313C131.5 29.4756 102.169 0.5 65.9998 0.5C29.8309 0.5 0.5 29.4756 0.5 65.2313C0.5 100.986 29.8309 129.962 65.9998 129.962Z"
      fill="#4E4848"
      fillOpacity="0.5"
      stroke="#D9BB7F"
    />
    <path
      d="M80.2129 64.3752C81.1632 64.9183 81.1632 66.2914 80.2129 66.8347L58.9644 78.9845C58.0226 79.5229 56.8516 78.8413 56.8516 77.7546V53.4552C56.8516 52.3683 58.0226 51.6867 58.9644 52.2254L80.2129 64.3752Z"
      fill="#D9BB7F"
    />
  </svg>
);
